import {
  Stack,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import React, { useState } from 'react';
import MyTableCell from '../../../components/material-ui/adaptive/MyTableCell';
import { useTranslation } from 'react-i18next';
import CusSiteDateTime from '../../../components/material-ui/CusSiteDateTime';
import TypographyText from '../../../components/material-ui/table/TypographyText';
import CusLink from '../../../components/material-ui/CusLink';
import InfoDialog from '../../../components/shared/InfoDialog';
import MessageDialog from './MessageDialog';
import { timezones } from '../../../enums/enums';

export default function HisMailingTable({ mailings = [] }) {
  const { t } = useTranslation();
  const [openMessage, setOpenMessage] = useState(false);

  const TypographyTitle = ({ children, text }) => (
    <Typography fontWeight={600} fontSize={12} lineHeight={'120%'}>
      {children || t(text)}
    </Typography>
  );

  const DateRow = ({ start, end }) => {
    if (!start && !end) return '-';
    if (start === end) return <CusSiteDateTime date={start} />;
    if (end)
      return (
        <>
          <CusSiteDateTime date={start} /> - <CusSiteDateTime date={end} />
        </>
      );

    return <CusSiteDateTime date={start} />;
  };

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <MyTableCell width={140}>
                <TypographyTitle text={'Mailing date'} />
              </MyTableCell>
              <MyTableCell width={130}>
                <TypographyTitle text={'Author of the newsletter'} />
              </MyTableCell>
              <MyTableCell>
                <TypographyTitle text={'Group'} />
              </MyTableCell>
              <MyTableCell>
                <TypographyTitle text={'Time zone'} />
              </MyTableCell>
              <MyTableCell isLess type="numeric">
                <TypographyTitle text={'Number of recipients'} />
              </MyTableCell>
              <MyTableCell isLess type="numeric">
                <TypographyTitle text={'Successfully sent'} />
              </MyTableCell>

              <MyTableCell isLess type="numeric">
                <TypographyTitle text={'Bot is blocked'} />
              </MyTableCell>
              <MyTableCell isLess type="numeric">
                <TypographyTitle text={'User deleted'} />
              </MyTableCell>
              <MyTableCell isLess type="numeric">
                <TypographyTitle text={'Other sending errors'} />
              </MyTableCell>
              <MyTableCell isLess type="numeric">
                <TypographyTitle text={'Number of unsent'} />
              </MyTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {mailings.map((row) => (
              <TableRow key={row.id}>
                <MyTableCell isSmall>
                  <DateRow start={row[2]} end={row[3]} />
                </MyTableCell>
                <MyTableCell isLess>
                  <Stack gap={0.5}>
                    <CusLink to={`/users/logs/${row[4]}/`} text={row[5]} />

                    <CusLink
                      fontSize={12}
                      text="Show message"
                      linkComponent="button"
                      onClick={() => setOpenMessage(String(row[1]))}
                    />
                  </Stack>
                </MyTableCell>
                <MyTableCell isLess>
                  <Typography fontSize={12} component={'span'} lineHeight={'110%'}>
                    <CusLink to={`/groups/${row[6]}`} text={row[7]} />{' '}
                    {row[8] ? (
                      <TypographyText fontSize={10} color="textSecondary">
                        ({t('including subgroups')})
                      </TypographyText>
                    ) : (
                      ''
                    )}
                  </Typography>
                </MyTableCell>
                <MyTableCell isSmall type="numeric">
                  {timezones.find((el) => el.value == row[16])?.label}
                </MyTableCell>
                <MyTableCell isSmall type="numeric">
                  {row[9]}
                </MyTableCell>
                <MyTableCell isSmall type="numeric">
                  {row[12]}
                </MyTableCell>
                <MyTableCell isSmall type="numeric">
                  {row[13]}
                </MyTableCell>
                <MyTableCell isSmall type="numeric">
                  {row[14]}
                </MyTableCell>
                <MyTableCell isSmall type="numeric">
                  {row[15]}
                </MyTableCell>
                <MyTableCell isSmall type="numeric">
                  {row[10]}
                </MyTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <MessageDialog
        open={openMessage}
        onClose={() => setOpenMessage(false)}
        messageId={openMessage}
      />
    </>
  );
}
